
export  const ACTIVITY_STATUS = {
    REQUESTED  : 'REQUESTED',
    APPROVED   : 'APPROVED',
    DECLINED   : 'DECLINED',
    PROCESSING : 'PROCESSING',
    CANCELED   : 'CANCELED',
    FAILED     : 'FAILED',
    SUCCEEDED  : 'SUCCEEDED'
};